import React from 'react'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { TextField } from 'redux-form-material-ui'
import RaisedButton from 'material-ui/RaisedButton'
import Paper from 'material-ui/Paper'
import Settings from 'material-ui/svg-icons/action/settings'
import { themeColors } from '../styles/theme'
import { required } from '../form/validation'

const styles = {
  containerStyle: {
    padding: 10,
  },
  title: {
    color: themeColors.positive,
    textTransform: 'uppercase',
  },
  titleIcon: {
    fill: themeColors.positive,
    position: 'relative',
    top: 5,
    marginRight: 5,
  },
  buttonLeft: {
    marginLeft: 10,
  },
  buttonRight: {
    marginLeft: 'auto',
    marginRight: 10,
  },
  inputContainer: {
    height: 70,
  },
  btnContainer: {
    paddingTop: 30,
    marginBottom: 10,
    display: 'flex',
  },
}

const validate = values => {
  const errors = {}

  if (
    values.password &&
    values.repeat_new_password &&
    values.password !== values.repeat_new_password
  ) {
    errors['repeat_new_password'] = 'Le due password non combaciano'
  }

  return errors
}

const ChangePasswordForm = ({ handleSubmit, submitting }) => (
  <Paper style={styles.containerStyle}>
    <div>
      <h3 style={styles.title}>
        <Settings style={styles.titleIcon} />Cambia Password
      </h3>
    </div>
    <form onSubmit={handleSubmit}>
      <div style={styles.inputContainer}>
        <Field
          name="current_password"
          type="password"
          component={TextField}
          validate={required}
          hintText="Password"
          floatingLabelText="Password"
          fullWidth={true}
        />
      </div>
      <div style={styles.inputContainer}>
        <Field
          name="password"
          type="password"
          component={TextField}
          validate={required}
          hintText="Nuova Password"
          floatingLabelText="Nuova Password"
          fullWidth={true}
        />
      </div>
      <div style={styles.inputContainer}>
        <Field
          name="repeat_new_password"
          type="password"
          component={TextField}
          validate={required}
          hintText="Ripeti Nuova Password"
          floatingLabelText="Ripeti Nuova Password"
          fullWidth={true}
        />
      </div>
      <div style={styles.btnContainer}>
        <RaisedButton
          disabled={submitting}
          label="Annulla"
          containerElement={<Link to="/profile" />}
          style={styles.buttonLeft}
          backgroundColor={themeColors.lightblack}
          labelColor={themeColors.white}
        />
        <RaisedButton
          disabled={submitting}
          type="submit"
          label="Modifica Password"
          primary={true}
          style={styles.buttonRight}
        />
      </div>
    </form>
  </Paper>
)

export default reduxForm({
  form: 'change-password-form',
  validate,
})(ChangePasswordForm)



// WEBPACK FOOTER //
// ./src/common/ChangePasswordForm.js